export const departmentsInitialState = {
  allDepartments: {
    data: [],
    loading: false,
    error: false,
    success: false,
  },
};
